import { createApiService } from '../../shared/services/api';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL?.replace(/\/$/, "") || 'http://localhost:3002';

export const apiService = createApiService(API_BASE_URL);

if (process.env.NEXT_PUBLIC_TENOR_API_KEY && process.env.NEXT_PUBLIC_TENOR_CLIENT_KEY) {
  apiService.setTenorKeys(
    process.env.NEXT_PUBLIC_TENOR_API_KEY,
    process.env.NEXT_PUBLIC_TENOR_CLIENT_KEY,
  );
}

if (process.env.NEXT_PUBLIC_KLIPY_API_KEY) {
  apiService.setKlipyKey(process.env.NEXT_PUBLIC_KLIPY_API_KEY);
}

export type {
  CreateUserRequest,
  CreateUserResponse,
  AuthRegisterResponse,
  LoginRequest,
  LoginResponse,
  PostReply,
  GetRepliesResponse,
  PostLikeEntry,
  GetLikesResponse,
  ApiResponse,
  CommunityJoinRequestItem,
  NotificationSettings,
  PostLike,
  GetPostLikesResponse,
  PostComment,
  GetPostCommentsResponse,
  PostData,
  CreatePostDto,
  User,
  TenorMediaFormat,
  TenorMediaFormats,
  TenorGif,
  TenorResponse,
  SuggestionRequest,
  SuggestionResponse,
  TrackLoginRequest,
  ChangePasswordRequest,
  TrackLoginResponse,
  UserTagEntry,
  UserTagsResponse,
  ReportType,
  ReportReason,
  ReportSubmissionRequest,
  UpdatePostVisibilityRequest,
  UpdatePostRequest,
  UpdatePostResponse,
  ConnectionRequestPayload,
  ConnectionRequestResponse,
} from '../../shared/services/api';

export { ApiService } from '../../shared/services/api';
